export const mutationType = {
    SEND_DOMAIN: 'SEND_DOMAIN',
    GET_DOMAIN: 'GET_DOMAIN',
    DELETE_DOMAINS: 'DELETE_DOMAINS',
}
